module.exports = __webpack_public_path__ + "static/media/amex.d97d46fe.svg";